import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm, FormsModule } from "@angular/forms";
import { Router, NavigationEnd, ActivatedRoute, DefaultUrlSerializer  } from '@angular/router';
declare var jQuery: any;
declare var $: any;
import * as moment from "moment";

@Component({
	selector: 'app-community',
	templateUrl: './community.component.html',
	styleUrls: ['./community.component.scss']
})
export class CommunityComponent implements OnInit {

	bannerrequest: any = {};
	bannerbottomrequest: any = {};
	textrequest: any = {};
	bannerList: any = "";
	bottombannerList: any = "";
	textList: any = "";
	newsList: any = "";
	schoolList: any = "";
	galleryList: any = "";
	governanceList: any = "";
	communityList: any = "";
	communitystaffList: any = {};
	aboutList: any = "";
	womensList: any = "";
	contactRequest: any = {};
	womensRequest: any = {};
	aboutRequest: any = {};
	communityRequest: any = {};
	contactError: any;
	contactSuccess: any;
	active_category = 17;
	clubList: any = {};
	newsrequest: any = {
		pagesize: 10,
		page: 1,
		news_catagory_id: this.active_category
	};

	constructor(private allpagesService: AllPageService,
		private activatedRoute:ActivatedRoute,
    private router: Router,) { this.loadnews(); }
	slidelatestConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 2,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidenewsConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	
	slidenewsoneConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideourstaffConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideaboutimageConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideaddConfig = {
		//dots: true,
		infinite: true,
		arrows: false,
		slidesToShow: 1,
		autoplay: true,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	ngOnInit() {
		this.activatedRoute.params.subscribe((data)=>{
			console.log(data);
			if(data.slug){
				this.tabactive(data.slug);
			  console.log(data.slug);
			  //this.newsRequest = data.slug;
			}
			
			});
		this.loadnews();
		this.loadBanner();
		this.loadaboutus();
		this.loadcommunity();
		this.loadcommunitystaff();
		this.loadwomens();
		this.loadschool();
		this.loadcommunituygovernance();
		this.loadcommunituyclub();
		this.allpagesService.getLetest().then((data) => {
			this.galleryList = data;
		});

		jQuery(".courses-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".courses-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".course-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");
			}
			return false;
		});
		
		setTimeout(() => {
			
		}, 1000);
	}

	tabactive(slug) {
		console.log(slug);
		jQuery(".courses-name").removeClass('active');
		jQuery(".course-main-content").removeClass('active');
		// if(slug == 'news'){
		// 	jQuery("#latest").addClass('active');
		// 	jQuery("#latest-content").addClass("active");		
		// }else
		if(slug == 'news'){
				jQuery("#about-us").addClass('active');
			jQuery("#about-us-content").addClass("active");
		}else if(slug == 'clubs'){
			jQuery("#club-cricket").addClass('active');
			jQuery("#club-cricket-content").addClass("active");
		}
		else if(slug == 'communitys'){
			jQuery("#community").addClass('active');
			jQuery("#community-content").addClass("active");
		}
		else if(slug == 'women-and-girls'){
			jQuery("#women-girls").addClass('active');
			jQuery("#women-girls-content").addClass("active");
		}else if(slug == 'schools'){
			jQuery("#schools").addClass('active');
			jQuery("#schools-content").addClass("active");
		}
		else if(slug == 'governance'){
			jQuery("#governanc").addClass('active');
			jQuery("#governanc-content").addClass("active");
		}
		else if(slug == 'safeguarding'){
			jQuery("#volunteering").addClass('active');
			jQuery("#volunteering-content").addClass("active");
		}
		else{
			jQuery("#about-us").addClass('active');
			jQuery("#about-us-content").addClass("active");
		}
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Community'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
		});

		this.bannerbottomrequest = {
			title: 'Community Bottom'
		};
		let requestnew = Object.assign({}, this.bannerbottomrequest);
		this.allpagesService.getBannerList(requestnew).then((data: any) => {
			this.bottombannerList = data.data[0];
		});

		this.textrequest = {
			title: 'Community'
		};
		let requesttext = Object.assign({}, this.textrequest);
		this.allpagesService.getContactText(requesttext).then((data: any) => {
			this.textList = data.data[0];
		});
	}

	clubContactus(form: NgForm) {
		if (form.valid) {
			this.contactRequest.type = 'Community';
			let request: any = {};
			request = Object.assign({}, this.contactRequest);
			this.allpagesService.getClubContactus(request).then((res) => {

				if (res.status == 0) {
					this.contactError = res.message;
				} else {
					this.contactSuccess = res.message;
					form.reset();
				}
			})
				.catch((err) => {
					this.contactError = err.res.message;
				});
		}
	}

	loadnews(concat: boolean = false) {
		let request = Object.assign({}, this.newsrequest);
		this.allpagesService.getNewsListing(request).then((data: any) => {

			if (data.data.length > 0) {
				if (concat) {
					this.newsList = this.newsList.concat(data.data);

				} else {
					this.newsList = data.data;
				}
			}
			else {


			}
		});
	}

	loadaboutus() {
		this.aboutRequest = { };
		let request = Object.assign({}, this.aboutRequest);
		this.allpagesService.getCommunityaboutus(request).then((data: any) => {
			this.aboutList = data;
		});
	}
	loadcommunity() {
		this.communityRequest = { };
		let request = Object.assign({}, this.communityRequest);
		this.allpagesService.getCommunity(request).then((data: any) => {
			this.communityList = data;
			setTimeout(() => {
				jQuery(".directions-faq .faq-title ").on("click", function () {
					jQuery(".directions-faq .faq-title").removeClass('active');
					if (jQuery(this).toggleClass('active')) {
						// do nothing
					}
					// return false;
				});
			}, 1000);
		});
	}
	loadcommunitystaff() {
		this.allpagesService.getCommunityStaff().then((data: any) => {
			this.communitystaffList = data.data;
		});
	}
	loadwomens() {
		this.womensRequest = { };
		let request = Object.assign({}, this.womensRequest);
		this.allpagesService.getCommunitywomencricket(request).then((data: any) => {
			this.womensList = data;
		});
	}
	loadschool() {
		this.womensRequest = { };
		let request = Object.assign({}, this.womensRequest);
		this.allpagesService.getCommunityschool(request).then((data: any) => {
			this.schoolList = data;
		});
	}
	loadcommunituygovernance() {
		this.womensRequest = { };
		let request = Object.assign({}, this.womensRequest);
		this.allpagesService.getCommunitygovernance(request).then((data: any) => {
			this.governanceList = data;
		});
	}
	loadcommunituyclub() {
		this.womensRequest = { };
		let request = Object.assign({}, this.womensRequest);
		this.allpagesService.getCommunityClub(request).then((data: any) => {
			this.clubList = data;
		});
	}

}
